export function fieldDef(namespaceOrField, fieldName) {
    const field = namespaceOrField;
    if (field?.name)
        return field;
    const namespace = typeof namespaceOrField === "string" ? namespaceOrField : undefined;
    if (fieldName)
        return { namespace, name: fieldName };
    return undefined;
}
//# sourceMappingURL=fieldDef.js.map